export default __webpack_public_path__ + "static/media/bilyana_xl.6a7d164b.jpg";